import React from "react";
import { trainEventRecord } from "./TrainEventRecordPageSelector";
import { TrainEventRecordSection } from "./TrainEventRecordSection";
import { TrainEventRecordView } from "./TrainEventRecordView";

export const TrainEventRecordSectionTrainEventRecord = () => {
    return (
        <TrainEventRecordSection
            page={trainEventRecord}
            pageView={TrainEventRecordView.TrainEventRecord}
        />
    );
};